export default __webpack_public_path__ + "static/media/login_foreground.52e0af50.png";